import React, { useCallback, useEffect, useRef, useState } from "react";

interface Props {
  menuRef: React.RefObject<HTMLDivElement>;
  isHorizontal: boolean;
  onDone: (payload: string) => void;
  onClose: () => void;
}

export const AddSectionHeaderForm: React.FC<Props> = ({
  menuRef,
  isHorizontal,
  onDone,
  onClose,
}) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const titleRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    titleRef.current?.focus();
  }, []);

  const handleSubmit = useCallback(() => {
    if (!title.trim()) {
      return;
    }
    onDone(JSON.stringify({ title: title.trim(), description: description.trim() }));
  }, [title, description, onDone]);

  return (
    <div
      ref={menuRef}
      className={`absolute z-50 bg-white rounded-2xl shadow-xl border border-gray-200 w-[360px] text-left ${
        isHorizontal ? "top-5" : "left-5"
      }`}
      onClick={e => e.stopPropagation()}
      onMouseDown={e => e.stopPropagation()}
    >
      <div className="px-5 pt-4 pb-3 flex items-center gap-2 text-sm font-bold text-gray-900 text-left">
        <span className="material-icons !text-lg text-indigo-500">title</span>
        Add Section Header
      </div>
      <div className="px-4 pb-3 space-y-3">
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Title</label>
          <input
            ref={titleRef}
            type="text"
            value={title}
            onChange={e => setTitle(e.target.value)}
            onKeyDown={e => {
              if (e.key === "Enter" && title.trim()) {
                e.preventDefault();
                handleSubmit();
              }
              if (e.key === "Escape") {
                onClose();
              }
            }}
            placeholder="Section title"
            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Description</label>
          <textarea
            value={description}
            onChange={e => {
              setDescription(e.target.value);
              e.target.style.height = "auto";
              e.target.style.height = e.target.scrollHeight + "px";
            }}
            onKeyDown={e => {
              if (e.key === "Escape") {
                onClose();
              }
            }}
            placeholder="Optional description"
            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
            rows={3}
          />
        </div>
        <div className="flex justify-end">
          <button
            onClick={handleSubmit}
            disabled={!title.trim()}
            className="px-4 py-1.5 bg-primary-button-background text-primary-button-foreground text-sm font-medium rounded-md hover:bg-primary-button-hover-background hover:text-primary-button-hover-foreground disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer transition-colors"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};
